import { useEffect, useState } from "react";
import { api, serviceLabel } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Handshake, MapPin } from "lucide-react";

export const RecommendedPros = ({ agentId, onQuote }) => {
  const [refs, setRefs] = useState([]);
  useEffect(() => { api.get(`/businesses/${agentId}/referrals`).then(({ data }) => setRefs(data)).catch(() => {}); }, [agentId]);
  if (!refs.length) return null;
  return (
    <div className="mt-6 border-t border-slate-100 pt-5 min-w-0" data-testid="recommended-pros">
      <h4 className="font-display font-bold text-[color:var(--navy)] mb-3 flex items-center gap-2"><Handshake className="w-4 h-4 text-[color:var(--emerald)]" /> Recommended Pros</h4>
      <div className="space-y-3 max-h-56 overflow-y-auto pr-1">
        {refs.map((r) => (
          <div key={r.id} className="p-3 rounded-xl bg-[color:var(--bg-3)]" data-testid={`recommended-pro-${r.id}`}>
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="font-semibold text-sm text-[color:var(--navy)] truncate">{r.name}</div>
                <div className="text-xs text-[color:var(--ink-3)] flex items-center gap-1"><MapPin className="w-3 h-3" /> {serviceLabel(r.category)} · {r.city}</div>
              </div>
              <Button size="sm" onClick={() => onQuote(r)} data-testid={`recommended-quote-${r.id}`} className="btn-amber rounded-full text-xs shrink-0">Request a Quote</Button>
            </div>
            {r.note && <p className="text-xs text-[color:var(--ink-2)] mt-2 italic">"{r.note}"</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
